/** @format */

import { useState, useCallback } from 'react';
import * as vendorService from '../services/vendorsService';
import { GlobalVendor } from '../types';

interface UseVendorsReturn {
  vendors: GlobalVendor[];
  loading: boolean;
  error: string | null;
  fetchVendors: () => Promise<void>;
  refetch: () => Promise<void>;
}

/**
 * Custom hook for fetching vendors
 */
export const useVendors = (): UseVendorsReturn => {
  const [vendors, setVendors] = useState<GlobalVendor[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchVendors = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await vendorService.getAllVendors();
      setVendors(data);
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Failed to fetch vendors';
      setError(errorMessage);
      console.error('Error fetching vendors:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  const refetch = useCallback(async () => {
    await fetchVendors();
  }, [fetchVendors]);

  return { vendors, loading, error, fetchVendors, refetch };
};
